import * as runtime from '../../runtime';
import { IInitializeServiceOptions } from '../../types';
import { SessionInfo } from './models';

export class IICsSessionService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}
	async getSessionInfoRaw(): Promise<runtime.ApiResponse<SessionInfo>> {
		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: '/api/v1/session/User',
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}
	async getSessionInfo(): Promise<SessionInfo> {
		const response = await this.getSessionInfoRaw();
		return response.value();
	}
}
export const initializeSessionService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const sessionService = new IICsSessionService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs.session,
		}),
		tenantId,
	);

	return sessionService;
};
